import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MsgInfoService } from './services/msg-info.service';
import { NightModeService } from './services/night-mode.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  title = 'project';

  constructor(
    private snackBar: MatSnackBar,
    private msgInfo: MsgInfoService,
    public nightModeService: NightModeService // 👈 important : public si utilisé dans le HTML
  ) {}

  ngOnInit(): void {
    this.msgInfo.subscribeInfo().subscribe((res: any) => {

      if (res && res.msg) {
        const msg =
          res.error &&
          (res.error.message || res.error.data || res.error !== '[object ProgressEvent]')
            ? res.error.message || res.error.data || res.error
            : res.msg;

        this.openSnackBar(msg, '', res.duration);
      } else {
        this.closeSnackBar();
      }
    });
  }

  openSnackBar(message: string, action: string, duration: number) {
    this.snackBar.open(message, action, {
      duration
    });
  }

  closeSnackBar() {
    this.snackBar.dismiss();
  }
}
